var _style, _path, _path2, _path3, _path4, _path5, _path6, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiIndexesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2731.6 2731.6",
    style: {
      enableBackground: "new 0 0 2731.6 2731.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;}\n\t.st1{fill:#DF10CD;}\n\t.st2{clip-path:url(#SVGID_00000022531910388579359860000008832480627754024124_);fill:#DF10CD;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2731.6,1365.8c0,754.3-611.5,1365.8-1365.8,1365.8S0,2120.1,0,1365.8S611.5,0,1365.8,0 S2731.6,611.5,2731.6,1365.8z M1365.8,236.4C742,236.4,236.4,742,236.4,1365.8S742,2495.2,1365.8,2495.2 s1129.4-505.7,1129.4-1129.4S1989.6,236.4,1365.8,236.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2282.1,1114c0,242.7-211.7,460.4-475.8,460.4c-265.8-9.4-475.8-217.7-475.8-460.4s211.7-454,475.8-460.4 C2070.4,660,2282.1,871.3,2282.1,1114z M2094,1114c0-154.9-128.8-280.5-287.7-280.5c-158.9,0-287.7,125.6-287.7,280.5 s128.8,280.5,287.7,280.5C1965.2,1394.6,2094,1269,2094,1114z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1700.1,1969.1c0,129.7-110.9,235.6-254.2,239.6c-142,0-254.2-109.9-254.2-239.6s113.3-240.6,254.2-240.6 C1586.9,1732.6,1700.1,1839.4,1700.1,1969.1z M1543.5,1969.1c0-52.6-43.7-95.2-97.6-95.2c-53.9,0-97.6,42.6-97.6,95.2 c0,52.6,43.7,95.2,97.6,95.2C1499.8,2064.3,1543.5,2021.7,1543.5,1969.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1074.4,971.9c-58.6,0-109.8,47-109.8,103.1c0,56,48.7,102.3,109.8,102.3c62.8,0,109.8-46.3,109.8-102.3 C1184.2,1018.9,1133.8,971.9,1074.4,971.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M707.9,1713.6c-58.6,0-109.8,47-109.8,103.1c0,56,48.7,102.3,109.8,102.3c62.8,0,109.8-46.3,109.8-102.3 C817.7,1760.7,767.3,1713.6,707.9,1713.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2032.8,1849.1c-58.6,0-109.8,47-109.8,103.1c0,56,48.7,102.3,109.8,102.3c62.8,0,109.8-46.3,109.8-102.3 C2142.7,1896.2,2092.3,1849.1,2032.8,1849.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 1365.8,
    cy: 1365.8,
    r: 1129.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088820605582398965070000005060730963031768974_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000088820605582398965070000005060730963031768974_)",
      fill: "#DF10CD"
    },
    d: "M971.7,633.6 c-7.9,129.5-125.1,228.3-268.4,223.7c-141.7-8.7-247-125.3-239.1-254.7c7.9-129.5,127.8-233.2,268.4-224.6 C873.2,390.6,979.7,504.1,971.7,633.6z M815.5,624c3.2-52.5-37.8-97.7-91.6-101c-53.8-3.3-100.1,36.6-103.3,89.1 c-3.2,52.5,37.8,97.7,91.6,101C766,716.4,812.3,676.5,815.5,624z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1927.1,751.3c40.4,0,75.5,14.6,104.7,44.2c29.4,29.4,44.2,64.5,44.2,104.7v932.6 c0,41.6-14.6,76.5-44.2,104.7c-29.4,28.2-64.5,42.4-104.7,42.4c-41.6,0-76.5-14.2-104.7-42.4c-28.2-28.2-42.4-63.3-42.4-104.7 V900.3c0-40.4,14.2-75.5,42.4-104.7C1850.6,765.9,1885.5,751.3,1927.1,751.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1029.1,1471.5c0-40.2,14.2-75.5,42.4-104.7c28.2-29.4,63.3-44.2,104.7-44.2h224.3v-49.5 c0-61.3-22-114.1-65.9-158.8c-43.8-44.5-96.5-66.7-157.8-66.7c-62.5,0-115.5,22.2-159.4,66.7c-43.8,44.5-65.9,97.5-65.9,158.8 v560c0,41.6-14.6,76.5-44.2,104.7c-29.6,28.2-64.5,42.4-104.7,42.4c-41.6,0-76.5-14.2-104.7-42.4 c-28.2-28.2-42.4-63.3-42.4-104.7v-570.4c4.6-140,55.9-259.1,153.4-358c97.7-98.7,220.2-150,368.2-153.4 c146.8,3.4,268.9,54.7,366.6,153.4c97.7,98.7,148.8,218,153.4,358v570.4c0,41.6-14.6,76.5-44.2,104.7 c-29.6,28.2-64.5,42.4-104.7,42.4c-41.6,0-76.5-14.2-104.9-42.4c-28.2-28.2-42.4-63.3-42.4-104.7v-214.2h-224.3 c-41.6,0-76.5-14.2-104.7-42.4C1043.3,1548.2,1029.1,1513.2,1029.1,1471.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1017.5,1114.3c-43.8,44.5-65.9,97.5-65.9,158.8v560c0,41.6-14.6,76.5-44.2,104.7 c-29.4,28.2-64.5,42.4-104.7,42.4c-41.6,0-76.5-14.2-104.7-42.4c-28.2-28.2-42.4-63.3-42.4-104.7v-570.4 c4.6-140,55.9-259.1,153.4-358"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIndexesIcon);
export default __webpack_public_path__ + "static/media/ai_indexes_icon.189f6c33c5bfff72345a7af3c423ace0.svg";
export { ForwardRef as ReactComponent };